export const SANDBOX_BASE_URL = import.meta.env.VITE_SANDBOX_BASE_URL;
export const PARTNER_TOKEN_URL = import.meta.env.VITE_PARTNER_TOKEN_URL;
export const COMPANY_TOKEN_URL = import.meta.env.VITE_COMPANY_TOKEN_URL;
export const PARTNER_COMPANIES_LIST_URL = import.meta.env
  .VITE_PARTNER_COMPANIES_LIST_URL;
export const PARTNER_USERS_LIST_URL = import.meta.env
  .VITE_PARTNER_USERS_LIST_URL;
